export default {
	getNotificationStatus(state) {
		return state.notificationStatus;
	},
	getNotifications(state) {
		return state.notificationContent
	},
	getNotificationCount(state) {
		return state.notificationCount
	}
};
